import { FC, useMemo } from "react";
import { Link } from "react-router-dom";
import { Center } from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import { CellProps, Column } from "react-table";
import TableComponent from "../../components/organism/Table/TableComponent";
import { primaryColor } from "../../utils/colors";

interface TableItems {
  id: number;
  name: string;
}

interface TableAuxiliaresProps {
  dataTable: TableItems[];
}

const TableAuxiliares: FC<TableAuxiliaresProps> = ({ dataTable }) => {
  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: "Nome",
        accessor: "name",
      },
      {
        Header: "Gerir",
        accessor: "edit",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any>) => (
          <Center justifyContent="flex-end">
            <Link to={`/tabelas-auxiliares/${row.original.id}`}>
              <EditIcon boxSize={6} mr="10px" color={primaryColor} />
            </Link>
          </Center>
        ),
      },
    ],
    [],
  );

  return (
    <TableComponent
      columns={columns}
      data={dataTable}
      fixedColumnIds={[{ value: "edit", hasShadow: true }]}
    />
  );
};

export default TableAuxiliares;
